import { library } from "@fortawesome/fontawesome-svg-core";
/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faMagnifyingGlass,
  faClose,
  faEllipsisV,
  faPencil,
  faCloudDownload,
  faTrash,
  faSpinner,
  faCloudUpload,
  faChevronUp,
  faChevronDown,
  faInfoCircle,
  faXmarkCircle,
  faExclamationTriangle,
  faCheck,
  faExclamationCircle,
  faPlus,
  faHouse,
  faArchive,
  faPowerOff,
  faArrowRight,
  faCheckCircle,
  faFilter,
  faFilePen,
  faEye,
  faFileCirclePlus,
  faRotateRight,
  faUserPen,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";

export const registerIcons = (app) => {
  library.add(faMagnifyingGlass);
  library.add(faClose);
  library.add(faEllipsisV);
  library.add(faPencil);
  library.add(faCloudDownload);
  library.add(faTrash);
  library.add(faSpinner);
  library.add(faCloudUpload);
  library.add(faChevronUp);
  library.add(faChevronDown);
  library.add(faInfoCircle);
  library.add(faXmarkCircle);
  library.add(faExclamationTriangle);
  library.add(faCheck);
  library.add(faExclamationCircle);
  library.add(faPlus);
  library.add(faHouse);
  library.add(faArchive);
  library.add(faInfoCircle);
  library.add(faPowerOff);
  library.add(faArrowRight);
  library.add(faCheckCircle);
  library.add(faFilter);
  library.add(faFilePen);
  library.add(faEye);
  library.add(faFileCirclePlus);
  library.add(faRotateRight);
  library.add(faUserPen);
  library.add(faUserGroup);

  app.component("font-awesome-icon", FontAwesomeIcon);

  return app;
};
